import styled from "styled-components"

export const Toggle = styled.button`
  position: relative;
  z-index: 80;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 48px;
  height: 48px;
  padding: 0 11px;
  background: none;
  border: 0;
  border-radius: var(--radius-sm);
  cursor: pointer;
  @media (min-width: 992px) {
    display: none;
  }
`

export const Bar = styled.span`
  display: block;
  width: 26px;
  height: 3px;
  border-radius: 2px;
  background: var(--color-text);
  transition: transform 0.25s ease, opacity 0.25s ease;
  ${({ $open, $pos }) =>
    $open && $pos === "top" && `transform: translateY(8px) rotate(45deg);`}
  ${({ $open, $pos }) => $open && $pos === "mid" && `opacity: 0;`}
  ${({
    $open,
    $pos,
  }) =>
    $open && $pos === "bottom" && `transform: translateY(-8px) rotate(-45deg);`}
`
